import "./App.css";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Layout from "./components/Layout";
import Login from "./pages/Login/Login";
import Registration from "./pages/Registartion";
import NotFound from "./pages/NotFound/NotFound";
import Orders from "./components/Ordres";
import Vehicles from "./pages/Vehicles/Vehicles";
import Staff from "./pages/Staff/Staff";
import Operation from "./pages/Operation/Operation";
import Services from "./pages/Services/Services";
import Clients from "./pages/Clients/Clients.jsx";
import Stock from "./pages/stock/Stock.jsx";
import Vendors from "./pages/stock/Vendors.jsx";
import Supplier from "./pages/stock/Supplier.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { IDProvider } from "./components/SharedModule/IdContext";
import { toast, ToastContainer } from "react-toastify";
// more imports...
import VanProfile from "./pages/Vehicles/VanProfile";
import OrderDetails from "./components/Modals/OrdersDetails";
import StaffVans from "./components/StaffVans";
import ActivityLog from "./components/ActivityLog";
import OrderDetailsUpdated from "./components/OrderDetailsUpdated";
import OrdersMap from "./components/OrdersMap";
import Activity from "./components/Activity";
import ServicesMainCard from "./pages/Services/Services_mainCard/ServicesMainCard.jsx";
import Authoriztion from "./pages/Authoriztion/Authoriztion.jsx";
import ClientInfo from "./pages/Clients/ClientInfo.jsx";
import SupplierProfile from "./pages/stock/SupplierProfile.jsx";
import BarCode from "./pages/stock/BarCode.jsx";
import ClientComments from "./components/ClientComments.jsx";
import Member from "./pages/Operation/Member/Member.jsx";
import OffersPage from "./pages/Services/Services_mainCard/OffersPage.jsx";
import License from "./components/Modals/License";
import AddVanLicense from "./components/Modals/AddVanLicense.jsx";
import Batches from "./pages/stock/Batches.jsx";
import AddNewReward from "./components/Rewards/AddNewReward.jsx";
import VariationProfile from "./pages/stock/VariationProfile.jsx";
import ArrangeOrders from "./pages/ArrangeOrders.jsx";
import { SidebarProvider } from "./components/SidebarProvider.jsx";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import CheckBefore from "./components/CarCheck/CheckBefore.jsx";
import CheckAfter from "./components/CarCheck/CheckAfter.jsx";
import PointsTransaction from "./components/Rewards/PointsTransaction.jsx";
import Coupons from "./components/Rewards/Coupons.jsx";
import CreateNewCoupon from "./components/Rewards/CreateNewCoupon.jsx";
import Offers from "./pages/Offers/Offers.jsx";
import AddNewOffer from "./pages/Offers/AddNewOffer.jsx";
import Categories from "./pages/Categories/Categories.jsx";
import Brands from "./pages/Brands/Brands.jsx";
import BrandsProfile from "./pages/Brands/BrandsProfile.jsx";
import CategoryProfile from "./pages/Categories/CategoryProfile.jsx";
import BrandCategoryProfile from "./pages/Categories/BrandCategoryProfile.jsx";
import SubCategoryProfile from "./pages/Categories/SubCategoryProfile.jsx";
import Manufacturers from "./pages/Manufacturers/Manufacturers.jsx";
import ManufactureProfile from "./pages/Manufacturers/ManufactureProfile.jsx";
import OfferProfile from "./pages/Offers/OfferProfile.jsx";
import Templates from "./pages/Notification/Templates.jsx";
import TemplateProfile from "./pages/Notification/TemplateProfile.jsx";
import NotificationsDashboard from "./pages/Notification/NotificationsDashboard.jsx";
import AutomatedNotif from "./pages/Notification/AutomatedNotif.jsx";
import UserGroup from "./pages/Notification/UserGroup.jsx";
import NotificationCategories from "./pages/Notification/NotificationCategories.jsx";
import TargetingRules from "./pages/Notification/TargetingRules.jsx";
import NotificationCampaigns from "./pages/Notification/NotificationCampaigns.jsx";
import BasicRewards from "./components/Rewards/BasicRewards.jsx";
import CircuitBreakers from "./pages/Notification/CircuitBreakers.jsx";
import VehiclesCategories from "./pages/New Vehicles/VehiclesCategories.jsx";
import VehiclesBrandProfile from "./pages/New Vehicles/VehiclesBrandProfile";
import BrandVehicle from "./pages/New Vehicles/BrandVehicle.jsx";
import Tables from "./pages/Equipments/Tables.jsx";
import NewEQprofile from "./pages/Equipments/NewEQprofile.jsx";
import EqCard from "./pages/NewEquipment/EqCard.jsx";
import EQModals from "./pages/NewEquipment/EQModals.jsx";
import RequestedEquipment from "./pages/NewEquipment/RequestedEquipment.jsx";
import SubCtegoery from "./pages/NewEquipment/SubCtegoery.jsx";
import OnSitePrices from "./pages/Services/OnSitePrices.jsx";
import Maintenance from "./components/User Requests/Maintenance.jsx";
import OtherServices from "./components/User Requests/OtherServices.jsx";
import Bundles from "./components/User Requests/Bundles.jsx";
import Otp from "./components/Otp/Otp.jsx";
import Home from "./pages/DriverFlow/Home.jsx";
import DayOrders from "./pages/DriverFlow/DayOrders.jsx";
import OrderServices from "./pages/DriverFlow/OrderServices.jsx";
import MaterialsForOrders from "./pages/DriverFlow/MaterialsForOrders.jsx";
import Servicess from "./pages/DriverFlow/Servicess.jsx";
import FinishOrderConfirmation from "./pages/DriverFlow/FinishOrderConfirmation.jsx";
import ServicesNotes from "./pages/DriverFlow/ServicesNotes.jsx";
// import CheckingTools from "./pages/DriverFlow/CheckingTools.jsx";
import Test from "./components/Test.jsx";
import TestVideo from "./components/TestVideo.jsx";
import Notes from "./pages/Staff/Notes.jsx";
import StaffProfile from "./pages/Staff/StaffProfile.jsx";
import Expenses from "./pages/Staff/Expenses.jsx";
import Sos from "./pages/DriverFlow/Sos.jsx";
import TripsHistory from "./pages/DriverFlow/TripsHistory.jsx";
import DriverProfile from "./pages/DriverFlow/DriverProfile.jsx";
import CheckingCars from "./pages/DriverFlow/CheckingCars.jsx";
import OrdersHistory from "./components/EngineerFlow/OrdersHistory.jsx";
import OrdersProductsCheck from "./components/EngineerFlow/OrdersProductsCheck.jsx";
import ConfirmProductsCheck from "./components/EngineerFlow/ConfirmProductsCheck.jsx";
import OrdersExecuting from "./components/EngineerFlow/OrdersExecuting.jsx";
import CheckingTools from "./components/EngineerFlow/CheckingTools.jsx";
import { useHorizontalScroll } from "./hooks/useHorizontalScroll.js";
import useActiveChecksPolling from "./hooks/useActiveChecksPolling.js";
import CheckOrderItems from "./components/EngineerFlow/CheckOrderItems.jsx";
import ImageBefore from "./components/EngineerFlow/ImageBefore.jsx";
import ImageAfter from "./components/EngineerFlow/ImageAfter.jsx";
import ConfirmPayment from "./components/EngineerFlow/ConfirmPayment.jsx";
import SosRequests from "./pages/Staff/SosRequests.jsx";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase.js";
import axios from "axios";
import AllNotificationsPage from "./components/NotificationPanel/AllNotificationsPage.jsx";
import HelpRequests from "./components/User Requests/HelpRequests.jsx";
import HelpRequestProfile from "./components/User Requests/HelpRequestProfile.jsx";
import Overview from "./pages/Incentives/Overview/Overview.jsx";
import AllIncentives from "./pages/Incentives/AllIncentives/AllIncentives.jsx";
import { ref, onValue } from "firebase/database";
import { database } from "./firebase";
import NewRequestAlert from "./components/NotificationPanel/NewRequestAlert.jsx";

function App() {

  const { user } = useSelector((state) => state.auth);
  
  const Token = user?.token;

  const location = useLocation();

  const navigate = useNavigate();

  const { pathWithoutLayout } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!user && !pathWithoutLayout.includes(location.pathname)) {
      navigate("/login");
    }
  }, [user, location]);

  const AdminRoles = ["super-admin", "admin", "supervisor", "agent", "outbound-agent"];

  const AgentRoles = [
    "follow-up",
    "provider",
    "outbound",
    "inbound",
    "order-manager",
    "engineer",
    "technician",
    "driver",
    "outbound-agent",
    "estbn-help-handler",
    "user",
    "agent  "
  ];

  const ifuserIsSupervisor =
    user?.operator?.roles?.length > 0
      ? user.operator.roles.some((e) => e.name === "supervisor")
      : user?.operator?.role === "supervisor";

  useHorizontalScroll();
  useActiveChecksPolling();

  // firbase effects 

  useEffect(() => {
    console.log("🔍 Token value:", Token);
    console.log("🔍 User value:", user);
    if (!Token) return;
    const initNotifications = async () => {
      console.log("🚀 initNotifications started");
      const permission = await Notification.requestPermission();
      console.log("🔔 Permission:", permission);
      if (permission !== "granted") {
        console.log("❌ Permission denied");
        return;
      }
      let registration;
      try {
        registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        console.log("⚙️ SW registered:", registration);
      } catch (err) {
        console.error("❌ SW registration error:", err);
        return;
      }
      console.log("📡 Getting FCM token...");
      try {
        const token = await getToken(messaging, {
          vapidKey: "BA9VY8GXetTRAMTvTCfU_eBYu6IJE6OJIKrCe2eSV9RZsMpsfj793KcgHkNHjJyrV6l5_hsAmME2Edq85S9hJAk",
          serviceWorkerRegistration: registration,
        });
        console.log("🔥 FCM TOKEN:", token);
        let deviceId = localStorage.getItem("device_id");
        if (!deviceId) {
          deviceId = Math.random().toString(36).substring(2);
          localStorage.setItem("device_id", deviceId);
        }
        const formData = new FormData();
        formData.append("device_token", token);
        formData.append("device_type", "web");
        formData.append("device_id", deviceId);
        await axios.post(
          "https://estbn.com/EstbnNew/public/api/save-fcm-token",
          formData,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );
        console.log("✅ Token saved to backend");
      } catch (err) {
        console.error("❌ getToken error:", err);
      }
    };

    initNotifications();

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📩 Foreground Message:", payload);

      const { title, body } = payload.notification;

      toast.info(
        <div>
          <strong>🔔 {title}</strong>
          <p style={{ margin: "4px 0 0", fontSize: "13px" }}>{body}</p>
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        }
      );
    });
    return () => unsubscribe();
  }, [Token]);

  // ===== New Request Alert State =====
  const [alertTrigger, setAlertTrigger] = useState(null);
  const nraPrevCountsRef = useRef(null);

  const nraApplyCounts = (newCounts) => {
    console.log("🔔 nraApplyCounts called:", newCounts);
    console.log("🔔 prevCounts:", nraPrevCountsRef.current);

    if (nraPrevCountsRef.current === null) {
      console.log("🔔 First time - saving without alert");
      nraPrevCountsRef.current = { ...newCounts };
      return;
    }

    const changedKeys = Object.keys(newCounts).filter(
      (k) => newCounts[k] > (nraPrevCountsRef.current[k] || 0)
    );

    console.log("🔔 changedKeys:", changedKeys);

    nraPrevCountsRef.current = { ...newCounts };

    if (changedKeys.length > 0) {
      console.log("🔔 Setting alert trigger:", changedKeys[0]);
      setAlertTrigger({ key: changedKeys[0], id: Date.now() });
    }
  };

  useEffect(() => {
    if (!Token) return;
    // Initial fetch
    axios
      .get("https://estbn.com/EstbnNew/public/api/portal/unread-count", {
        headers: { Authorization: `Bearer ${Token}` },
      })
      .then((res) => {
        const d = res.data;
        nraApplyCounts({
          sos: d.unread_count || 0,
          maintenance: d.unread_price_plan_request_count || 0,
          otherServices: d.unread_other_request_count || 0,
          helpRequests: d.unread_help_count || 0,
        });
      })
      .catch(console.error);
  }, [Token]);

  useEffect(() => {
    if (!Token) return;
    const unreadRef = ref(database, "unread_count");
    const unsubscribe = onValue(unreadRef, () => {
      axios
        .get("https://estbn.com/EstbnNew/public/api/portal/unread-count", {
          headers: { Authorization: `Bearer ${Token}` },
        })
        .then((res) => {
          const d = res.data;
          nraApplyCounts({
            sos: d.unread_count || 0,
            maintenance: d.unread_price_plan_request_count || 0,
            otherServices: d.unread_other_request_count || 0,
            helpRequests: d.unread_help_count || 0,
          });
        })
        .catch(console.error);
    });
    return () => unsubscribe();
  }, [Token]);

  return (
    
    <SidebarProvider>
      <IDProvider>
        <NewRequestAlert trigger={alertTrigger} />
        <Layout>
          <Routes>
            <Route
              path="login"
              element={!user ? <Login /> : <Navigate to="/orders" />}
            />
            <Route
              path="registration"
              element={
                !user ? (
                  <Registration />
                ) : ifuserIsSupervisor ? (
                  <Navigate to="/orders" />
                ) : (
                  <Navigate to="/orders" />
                )
              }
            />
            <Route
              path="otp"
              element={<Otp />}
            />
            {/* driver routes */}
            <Route path="Home" element={<Home />} />
            <Route path="dayOrders" element={<DayOrders />} />
            <Route path="dayOrders/:id" element={<OrderServices />} />
            <Route path="Materials" element={<MaterialsForOrders />} />
            <Route path="engineerService" element={<Servicess />} />
            <Route path="OrderConfirmation" element={<FinishOrderConfirmation />} />
            <Route path="ServiceNotes" element={<ServicesNotes />} />
            <Route path="checkCar" element={<CheckingCars />} />
            <Route path="trips" element={<TripsHistory />} />
            <Route path="sos" element={<Sos />} />
            <Route path="profile" element={<DriverProfile />} />
            {/* engineer routes */}
            <Route path="ordersExecution" element={<OrdersExecuting />} />
            <Route path="ordersExecution/checkItems/:id" element={<CheckOrderItems />} />
            <Route path="ordersExecution/checkItems/:id/imageBefore" element={<ImageBefore />} />
            <Route path="ordersExecution/checkItems/:id/imageAfter" element={<ImageAfter />} />
            <Route path="ordersExecution/checkItems/:id/confirmPayment" element={<ConfirmPayment />} />
            <Route path="ordersHistory" element={<OrdersHistory />} />
            <Route path="ordersProductsCheck" element={<OrdersProductsCheck />} />
            <Route path="ordersProductsCheck/confirmCheck/:id" element={<ConfirmProductsCheck />} />
            <Route path="ordersExecution/:id" element={<OrdersExecuting />} />
            <Route path="checkingtools" element={<CheckingTools />} />
            <Route path="/notifications" element={<AllNotificationsPage />} />
            {/* operation routes */}
            <Route element={<ProtectedRoute allowedRoles={[...AgentRoles, ...AdminRoles]} />}>
              <Route path="/" element={!ifuserIsSupervisor ? <Orders /> : <Navigate to="/orders" />} />
              <Route path="/notifications" element={<AllNotificationsPage />} />
              <Route path="orders" element={<Orders />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="vehicles" element={<Vehicles />} />
              <Route path="vehicles/:id" element={<VanProfile />} />
              <Route path="ordersdetails" element={<OrderDetails />} />
              <Route path="staff-vans" element={<StaffVans />} />
              <Route path="ActivityLog" element={<ActivityLog />} />
              <Route path="OrderDetailsUpdated" element={<OrderDetailsUpdated />} />
              <Route path="orders/:id" element={<OrderDetailsUpdated />} />
              <Route path="Map" element={<OrdersMap />} />
              <Route path="Activity" element={<Activity />} />
              <Route path="Activity/:id" element={<Activity />} />
              <Route path="arrangeorders" element={<ArrangeOrders />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super-admin", "admin", "supervisor", "outbound-agent"]} />}>
              <Route path="permissions" element={<Authoriztion />} />
              <Route path="staff" element={<Staff />} />
              <Route path="staff/:id" element={<StaffProfile />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="notes" element={<Notes />} />
              <Route path="sosRequests" element={<SosRequests />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="maintenance/:id" element={<Maintenance />} />
              <Route path="requests" element={<OtherServices />} />
              <Route path="requests/:id" element={<OtherServices />} />
              <Route path="helpRequests" element={<HelpRequests />} />
              <Route path="helpRequests/:id" element={<HelpRequestProfile />} />
              <Route path="bundles" element={<Bundles />} />
              <Route path="other" element={<Maintenance />} />
              <Route path="operation" element={<Operation />} />
              <Route path="operation/:id" element={<Member />} />
              <Route path="services" element={<Services />} />
              <Route path="services/:id" element={<ServicesMainCard />} />
              <Route path="services/:id/Pervisit" element={<OnSitePrices />} />
              <Route path="services/:id/offers" element={<OffersPage />} />
              <Route path="equipments" element={<EqCard />} />
              <Route path="EQmodal" element={<EQModals />} />
              <Route path="subcategory" element={<SubCtegoery />} />
              <Route path="requested" element={<RequestedEquipment />} />
              <Route path="AllEquipments" element={<Tables />} />
              <Route path="AllEquipments/:eqId" element={<NewEQprofile />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientInfo />} />
              <Route path="stock" element={<Stock />} />
              <Route path="stock/:productId" element={<VariationProfile />} />
              <Route path="stock/:productId/batches" element={<Batches />} />
              <Route path="stock/:productId/batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="stock/vendors" element={<Vendors />} />
              <Route path="stock/vendors/supplier" element={<Supplier />} />
              <Route path="stock/vendors/supplier/:id" element={<Supplier />} />
              <Route path="stock/vendors/:id" element={<SupplierProfile />} />
              <Route path="comments" element={<ClientComments />} />
              <Route path="comments/:id" element={<ClientComments />} />
              <Route path="checkBefore/:id" element={<CheckBefore />} />
              <Route path="checkAfter/:id" element={<CheckAfter />} />
              <Route path="comments/:id" element={<ClientComments />} />
              <Route path="License" element={<License />} />
              <Route path="AddVanLicense" element={<AddVanLicense />} />
              <Route path="NotifcationsDashboard" element={<NotificationsDashboard />} />
              <Route path="AutomatedNotification" element={<AutomatedNotif />} />
              <Route path="Templates" element={<Templates />} />
              <Route path="Templates/:id" element={<TemplateProfile />} />
              <Route path="Usergroup" element={<UserGroup />} />
              <Route path="Notification Categories" element={<NotificationCategories />} />
              <Route path="targetingRules" element={<TargetingRules />} />
              <Route path="notificationCampaigns" element={<NotificationCampaigns />} />
              <Route path="CircuitBreakers" element={<CircuitBreakers />} />
              <Route path="Rewards" element={<BasicRewards />} />
              <Route path="AddNewReward" element={<AddNewReward />} />
              <Route path="pointsTransaction" element={<PointsTransaction />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="coupons/:id" element={<CreateNewCoupon />} />
              <Route path="coupons/createNewCoupon" element={<CreateNewCoupon />} />
              <Route path="offers" element={<Offers />} />
              <Route path="offers/AddNewOffer" element={<AddNewOffer />} />
              <Route path="offers/edit/:id" element={<AddNewOffer />} />
              <Route path="offers/:id" element={<OfferProfile />} />
              <Route path="Categories" element={<Categories />} />
              <Route path="Categories/:id" element={<CategoryProfile />} />
              <Route path="Categories/:id/subcategory/:subCatId" element={<SubCategoryProfile />} />
              <Route path="Categories/:id/brand/:brandId" element={<BrandCategoryProfile />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId" element={<BrandCategoryProfile />} />
              <Route path="Categories/:id/brand/:brandId/Products/:productId" element={<VariationProfile />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId/Products/:productId" element={<VariationProfile />} />
              <Route path="Categories/:id/brand/:brandId/Products/:productId/Batches" element={<Batches />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId/Products/:productId/Batches" element={<Batches />} />
              <Route path="Categories/:id/brand/:brandId/Products/:productId/Batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId/Products/:productId/Batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="Brands" element={<Brands />} />
              <Route path="Brands/:id" element={<BrandsProfile />} />
              <Route path="Brands/:id/Products/:productId" element={<VariationProfile />} />
              <Route path="Brands/:id/Products/:productId/Batches" element={<Batches />} />
              <Route path="Brands/:id/Products/:productId/Batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="manufacturers" element={<Manufacturers />} />
              <Route path="manufacturers/manufactureProfile/:id" element={<ManufactureProfile />} />
              <Route path="vehiclesCategories" element={<VehiclesCategories />} />
              <Route path="vehiclesCategories/:categoryId" element={<BrandVehicle />} />
              <Route path="vehiclesCategories/:categoryId/vehiclesBrand/:brandId" element={<VehiclesBrandProfile />} />
              <Route path="/overView" element={<Overview />} />
              <Route path="/incentives" element={<AllIncentives />} />
              <Route path="/image" element={<Test />} />
              <Route path="/video" element={<TestVideo />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <ToastContainer />
      </IDProvider>
    </SidebarProvider>
  );
}

export default App;
